import { FC, PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'

const ProtectedRoutes: FC<PropsWithChildren> = ({ children }) => {
  const auth = { token: true }
  return auth.token ? <>{children}</> : <Navigate to="/auth/login" />
}

export default ProtectedRoutes
